var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModalActionConfirmation',{ref:"modalConfirmation",attrs:{"message":"Você possui algumas alterações que não foram salvas. O que deseja fazer?","btnCancelText":"Sair sem salvar","btnConfirmText":"Salvar alterações"},on:{"cancelled":function($event){return _vm.close()},"confirmed":function($event){return _vm.save()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }